import { ChevronDown } from "lucide-react";
import { AUXILIARY_ROLES_GUIDE } from "@/lib/auxiliaryRoleGuide";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

/** Referencia breve de permisos por rol — no invasiva, colapsable. */
export default function AuxiliaryRolesGuide() {
  return (
    <Accordion type="single" collapsible className="rounded-md border border-slate-200 bg-slate-50/80">
      <AccordionItem value="roles" className="border-0">
        <AccordionTrigger
          className="px-4 py-3 text-xs font-semibold text-[#0F2D5C] hover:no-underline"
          data-testid="equipo-roles-guide-trigger"
        >
          <span className="flex items-center gap-2">
            Permisos por rol
            <ChevronDown className="w-3.5 h-3.5 text-slate-500 shrink-0" aria-hidden />
          </span>
        </AccordionTrigger>
        <AccordionContent className="px-4 pb-4 pt-0">
          <ul className="space-y-2 m-0 p-0 list-none text-[11px] text-slate-700 leading-relaxed">
            {AUXILIARY_ROLES_GUIDE.map((row) => (
              <li key={row.key} data-testid={`equipo-role-guide-${row.key}`}>
                <span className="font-semibold text-[#0F2D5C]">{row.title}:</span> {row.body}
              </li>
            ))}
          </ul>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
